class MainHeader extends HTMLElement {
  constructor() {
    super();
    this.currentScrollTop = 0;

    if (this.classList.contains('on_scroll_up')) {
      window.addEventListener('scroll', this.onScroll.bind(this), false);
    }

    window.addEventListener('scroll', this.announcementHeightCal.bind(this), false);
    window.addEventListener('scroll', this.transparentHeader.bind(this), false);
    this.addEventListener('mouseover', this.transparentHeaderAdd.bind(this), false);
    this.addEventListener('mouseout', this.transparentHeaderRemove.bind(this), false);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.headerHeight = this?.getBoundingClientRect().height.toFixed(2) || 0;

    if (scrollTop > 100) {
      if (scrollTop > this.currentScrollTop) {
        this.classList.add('header-sticky-hide');
        document.body.style.setProperty('--header-height', `0px`);
      } else {
        this.classList.remove('header-sticky-hide');
        document.body.style.setProperty('--header-height', `${this.headerHeight}px`);
      }
    } else {
      this.classList.remove('header-sticky-hide');
      document.body.style.setProperty('--header-height', `${this.headerHeight}px`);
    }

    this.currentScrollTop = scrollTop;
  }

  announcementHeightCal() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.setProperty('--announcement-height', `${Math.max((this.announcementHeight - scrollTop), 0)}px`);
  }

  headerHeightupdate() {
    this.announcementHeight = document.querySelector('.announcement-bar')?.getBoundingClientRect().height.toFixed(2) || 0;
    this.headerHeight = this.getBoundingClientRect().height.toFixed(2) || 0;
    document.body.style.setProperty('--announcement-height', `${this.announcementHeight}px`);
    document.body.style.setProperty('--header-height', `${this.headerHeight}px`);
  }

  transparentHeader() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 20) {
      this.classList.add('is-scrolled');
    } else {
      this.classList.remove('is-scrolled');
    }

    if (this.classList.contains('transparent')) {
      if (scrollTop > 110) {
        this.classList.add('background-header-color');
      } else {
        this.classList.remove('background-header-color');
      }
    }

    this.currentScrollTop = scrollTop;
  }

  transparentHeaderAdd() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= 110 && this.classList.contains('transparent') && !this.classList.contains('background-header-color')) {
      this.classList.add('background-header-color');
    }
  }

  transparentHeaderRemove() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= 110 && this.classList.contains('transparent') && this.classList.contains('background-header-color')) {
      this.classList.remove('background-header-color');
    }
  }
}

customElements.define('main-header', MainHeader);

class HeaderDrawerMenu extends HTMLElement {
  constructor() {
    super();
    this.headerSection = this.closest('.main-header-section');
    this.closeBtns = this.querySelectorAll('[data-close-drawer]');
    this.drawerBtns = this.headerSection?.querySelectorAll('[data-drawer-head]') || [];
    this.lastFocusedElement = "";

    this.closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener("click", () => this.closeDrawer());
    });

    this.drawerBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => this.toggleDrawer(e, btn));
    });

    this.subMenuEvents();
  }

  toggleDrawer(event, clickedBtn) {
    const isActive = this.classList.contains('is-visible');

    if (isActive) {
      this.closeDrawer();
    } else {
      this.openDrawer(event, clickedBtn);
    }
  }

  openDrawer(event, clickedBtn) {
    document.body.classList.add('overflow-hidden');
    this.classList.add('is-visible');
    this.drawerBtns.forEach(btn => btn.classList.add('is-active'));
    this.lastFocusedElement = clickedBtn;

    setTimeout(() => {
      focusElement = event.target;
      trapFocusElements(this);
    }, 300);
  }

  closeDrawer() {
    document.body.classList.remove('overflow-hidden');
    this.classList.remove('is-visible');
    this.drawerBtns.forEach(btn => btn.classList.remove('is-active'));
    const menuelement = document.querySelector("header-drawer button");

    setTimeout(() => {
      this.querySelectorAll('[data-submenu-wrapper].is-active').forEach(subMenu => {
        subMenu.classList.remove('is-active');
      });

      this.querySelectorAll('[data-grand-submenu-wrapper].is-active').forEach(grandMenu => {
        grandMenu.classList.remove('is-active');
      });

      this.querySelectorAll('[data-submenu-open].is-active, [data-grand-submenu-toggle].is-active, [data-menu-link].is-active, [data-submenu-link].is-active').forEach(activeItem => {
        activeItem.classList.remove('is-active');
      });

      this.querySelectorAll('[aria-expanded="true"]').forEach(item => {
        item.setAttribute('aria-expanded', 'false');
      });
    }, 400);

    setTimeout(() => {
      if (menuelement) menuelement.focus();
      this.lastFocusedElement = '';
    }, 500);
  }

  subMenuEvents() {
    const toggleSubmenu = (trigger, event = null) => {
      const wrapper = trigger.closest('[data-menu-link]');
      const subMenuWrapper = wrapper?.querySelector('[data-submenu-wrapper]');

      if (!wrapper || !subMenuWrapper) return;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const shouldOpen = !subMenuWrapper.classList.contains('is-active');

      this.querySelectorAll('[data-submenu-wrapper].is-active').forEach(el => {
        if (el !== subMenuWrapper) el.classList.remove('is-active');
      });

      this.querySelectorAll('[data-submenu-open].is-active').forEach(el => {
        if (el !== trigger) {
          el.classList.remove('is-active');
          el.setAttribute('aria-expanded', 'false');
        }
      });

      this.querySelectorAll('[data-menu-link].is-active').forEach(el => {
        if (el !== wrapper) el.classList.remove('is-active');
      });

      subMenuWrapper.classList.toggle('is-active', shouldOpen);
      trigger.classList.toggle('is-active', shouldOpen);
      wrapper.classList.toggle('is-active', shouldOpen);
      trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    };

    const toggleGrandSubmenu = (trigger, event = null) => {
      const wrapper = trigger.closest('[data-submenu-link]');
      const grandWrapper = wrapper?.querySelector('[data-grand-submenu-wrapper]');

      if (!wrapper || !grandWrapper) return;

      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      const shouldOpen = !grandWrapper.classList.contains('is-active');

      this.querySelectorAll('[data-grand-submenu-wrapper].is-active').forEach(el => {
        if (el !== grandWrapper) el.classList.remove('is-active');
      });

      this.querySelectorAll('[data-grand-submenu-toggle].is-active').forEach(el => {
        if (el !== trigger) {
          el.classList.remove('is-active');
          el.setAttribute('aria-expanded', 'false');
        }
      });

      this.querySelectorAll('[data-submenu-link].is-active').forEach(el => {
        if (el !== wrapper) el.classList.remove('is-active');
      });

      grandWrapper.classList.toggle('is-active', shouldOpen);
      trigger.classList.toggle('is-active', shouldOpen);
      wrapper.classList.toggle('is-active', shouldOpen);
      trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    };

    this.querySelectorAll('[data-submenu-open]').forEach(trigger => {
      trigger.addEventListener('click', (event) => toggleSubmenu(trigger, event));
    });

    this.querySelectorAll('[data-grand-submenu-toggle]').forEach(trigger => {
      trigger.addEventListener('click', (event) => toggleGrandSubmenu(trigger, event));
    });
  }
}

customElements.define('header-menu-drawer', HeaderDrawerMenu);

class MobileHamburgerMenu extends HTMLElement {
  constructor() {
    super();
    this.body = document.body;
    this.header = document.querySelector("header");
    this.mobileHamburgerElements = document.querySelectorAll("[data-hamburger-mobile]");
    this.backToNavElements = document.querySelectorAll("[data-backtonav-items], [data-subbacktonav-items]");
    this.closeElements = document.querySelectorAll("[data-mobile-menu-close]");
    this.lastFocusedElement = "";
  }

  connectedCallback() {
    this.initHamburgerMenu();
    this.initMobileMenuItems();
    this.initMenuCloseTriggers();
    this.handleResize();
  }

  initHamburgerMenu() {
    this.mobileHamburgerElements.forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        const drawerSelector = element.getAttribute("href");
        const contentDrawerContainer = document.querySelector(drawerSelector);

        if (element.classList.contains("active")) {
          this.closeMenu(element, contentDrawerContainer);
        } else {
          element.classList.add("active");
          this.body.classList.add("overflow-hidden", "mobile-menu-active");

          if (contentDrawerContainer) {
            contentDrawerContainer.classList.add("is-active");
          }
        }

        setTimeout(() => {
          focusElement = event.target;
          if (contentDrawerContainer) trapFocusElements(contentDrawerContainer);
        }, 300);
      });
    });
  }

  initMenuCloseTriggers() {
    this.closeElements.forEach((closeBtn) => {
      closeBtn.addEventListener("click", (event) => {
        event.preventDefault();

        const drawerSelector = closeBtn.getAttribute("data-mobile-menu-close");
        const contentDrawerContainer = document.querySelector(drawerSelector);

        this.mobileHamburgerElements.forEach(el => el.classList.remove("active"));
        this.body.classList.remove("mobile-menu-active", "overflow-hidden");

        if (contentDrawerContainer) {
          contentDrawerContainer.classList.remove("is-active");
          this.resetMobileMenuState(contentDrawerContainer);
        }

        setTimeout(() => {
          if (typeof focusElement !== "undefined" && focusElement && typeof focusElement.focus === "function") {
            focusElement.focus();
          }

          this.lastFocusedElement = '';
        }, 300);
      });
    });
  }

  initMobileMenuItems() {
    document.querySelectorAll(".mobile-menu-slide-dropdown-detail > summary.mobile-menu-slide-link").forEach((summary) => {
      summary.addEventListener("click", () => {
        const details = summary.closest(".mobile-menu-slide-dropdown-detail");
        const container = details?.closest("[data-child-items]");

        if (container) {
          container.classList.add("active");
        }
      });
    });

    this.backToNavElements.forEach((backItem) => {
      backItem.addEventListener("click", (event) => {
        event.preventDefault();

        const details = event.target.closest("details[open]");
        const activeChild = event.target.closest("[data-child-items].active");

        if (details) details.removeAttribute("open");
        if (activeChild) activeChild.classList.remove("active");
      });
    });
  }

  handleResize() {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 991 && this.body.classList.contains("mobile-menu-active")) {
        this.body.classList.remove("mobile-menu-active", "overflow-hidden");

        document.querySelectorAll("[data-hamburger-mobile]").forEach(el => el.classList.remove("active"));

        document.querySelectorAll("[data-mobile-drawer-content]").forEach(drawer => {
          drawer.classList.remove("is-active");
          this.resetMobileMenuState(drawer);
        });
      }
    });
  }

  closeMenu(triggerElement, drawerElement) {
    this.body.classList.remove("overflow-hidden", "mobile-menu-active");
    triggerElement.classList.remove("active");

    if (drawerElement) {
      drawerElement.classList.remove("is-active");
      this.resetMobileMenuState(drawerElement);
    }
  }

  resetMobileMenuState(drawerElement) {
    drawerElement.querySelectorAll("details[open]").forEach(details => {
      details.removeAttribute("open");
    });

    drawerElement.querySelectorAll("[data-child-items].active").forEach(item => {
      item.classList.remove("active");
    });
  }
}

customElements.define("mobile-hamburger-menu", MobileHamburgerMenu);